<!--
 * @Author: your name
 * @Date: 2020-11-05 13:46:25
 * @LastEditTime: 2021-05-27 16:07:16
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \znjz-vue\src\components\index\news.vue
-->
<template>
  <div class="type-page news">
    <div class="news-title">
        <h1>资讯通告 <span @click="$router.push('/news')">More +</span></h1>
    </div>
    <p class="rich-title">News</p>
    <div class="notice clearfix" v-if="newsList.list1">
        <div class="new-list fl clearfix">
            <img :src="newsList.list1[0].image" alt="">
            <div class="new-list-info fr">
                <h1 class="ellipsis">{{newsList.list1[0].title}} <br /><span>{{newsList.list1[0].create_time}}</span></h1>
                <p class="ellipsis2">{{newsList.list1[0].intro}}</p>
                <router-link :to="`/noticeDetail?id=${newsList.list1[0].id}`" class="new-look">查看详情</router-link>
            </div>
        </div>
        <div class="new-list fr clearfix" >
            <div class="new-list-info new-list-w" >
                <h1 class="ellipsis">{{newsList.list1[1].title}}<br /><span>{{newsList.list1[1].create_time}}</span></h1>
                <p class="ellipsis2">{{newsList.list1[1].intro}}</p>
                <router-link :to="`/noticeDetail?id=${newsList.list1[1].id}`" class="new-look">查看详情</router-link>
            </div>
        </div>
    </div>
    <ul>
        <li
        v-for="item of newsList.list2"
        :key="item.id"
       
        ><i></i><span class="n-time" >{{item.create_time}}</span><span class="n-title"  @click="jumpDetail(item.id)">{{item.title}}</span></li>
    </ul>
  </div>
</template>

<script>
export default {
    props: ['newsList'],
    data(){
      return {
      }  
    },
    methods: {
        jumpDetail(newid){
            this.$router.push({
                path:'/noticeDetail',
                query: {
                    id: newid
                }
            })
        },
        // jumpNews(){
        //     this.$router.push({
        //         path:'/news',
        //         query: {
        //             tabs: 2
        //         }
        //     })
        // }

    }
}
</script>

<style scoped lang="scss">
.type-page {
    padding:80px 0 75px ;
}
 
.news-title {
   h1 {
    font-size: 18px;
    font-weight: bold;
    color: #2B2F37;
    span {
        font-size: 14px;
        font-weight: 400;
        color: #4165FF !important;
        float: right;
        cursor: pointer;
      }
    }
}
.rich-title {
    color: #999;
    margin-top: 9px;
}
.notice {
    margin-top: 10px;
}
.new-list {
    position: relative;
    background: url(./../../assets/image/Authentication_bg2.png) 0 0 no-repeat;
    background-size: 100% 100%;
    width: 49.5%;
    height: 192px;
    padding: 20px 16px;
    // background-color: #fff;
    img {
        width: 216px;
        height: 150px;
        float: left;
    }
}
.new-list-w {
    width: 100% !important;
}
.new-list-info {
    width: 58% ;
    
     h1 {
        font-size: 18px;
        font-weight: bold;
        color: #2B2F37;
        margin-top: 15px;
        span {
            font-size: 14px;
            font-weight: 400;
            color: #999999;
            line-height: 30px;
        }
    }
    p {
        margin-top: 15px;
        line-height: 1.2;
    }
    .new-look {
        color: #4165FF;
        line-height: 35px;
        position: absolute;
        bottom: 16px;
        right: 16px;
    }
}
.news {
    ul {
        margin-top: 64px;
        li {
            margin: 10px 0;
            font-size: 16px;
            cursor: default;
            i {
                list-style: none;
                width: 8px;
                height: 8px;
                border-radius: 50%;
                background-color: #4165FF;
                display: inline-block;
                margin-right:8px
            }
            .n-time{
                color: #999;
                margin-right: 23px;
                vertical-align: text-bottom;
            }
            .n-title {
                cursor: pointer;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/index/news.vue